import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import BranchPickerModal from "@/components/site/BranchPickerModal";

export default function WhatsAppFAB() {
  const [open, setOpen] = useState(false);

  const handleSelect = (branch) => {
    const msg = encodeURIComponent(
      `Hola ${branch.name}, quiero información sobre los cursos del Instituto Europa.`
    );
    window.open(`https://wa.me/${branch.whatsapp}?text=${msg}`, "_blank", "noopener");
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="whatsapp-fab"
        aria-label="Contactar por WhatsApp"
        className="wa-pulse fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25d366] text-white flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(37,211,102,0.55)] hover:bg-[#1ebe5d] transition-colors"
      >
        <MessageCircle size={26} strokeWidth={1.7} />
      </button>

      <BranchPickerModal
        open={open}
        mode="whatsapp"
        course={null}
        onClose={() => setOpen(false)}
        onSelect={handleSelect}
      />
    </>
  );
}
